import { useMediaQuery } from 'react-responsive';

// export const Desktop: React.ComponentType<ResponsiveProps> = ({ children }) => (
//     <Responsive minWidth={481}>
//         {children}
//     </Responsive>
// );

// export const Mobile: React.ComponentType<ResponsiveProps> = ({ children }) => (
//     <Responsive maxWidth={480}>
//         {children}
//     </Responsive>
// );

export const useMobile = () => {
    const result = useMediaQuery({ query: '(max-width: 480px)' });
    return result;
};
